import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import { useReactToPrint } from "react-to-print";


const AdminSale = () => {
  const [responseMessage, setResponseMessage] = useState("");
  const [formData, setFormData] = useState({
    invoice_date: "",
    member_clientid: "",
    customer_name: "",
    customer_mobile: "",
    customer_address: "",
    amount_received: "",
    plot_id: "",
    plot_number: "",
    plot_name: "",
    total_sqfeet: "",
    total_amount: "",
    category: "",
    due_amount: "",
    payment_mode: "",
    description: "",
  });
  const [plots, setPlots] = useState([]);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [showInvoice, setShowInvoice] = useState(false);
  const [plotData, setPlotData] = useState({
    length: '',
    breadth: '',
  })
  // const [totalAmount, setTotalAmount] = useState(0);
  // const [dueAmount, setDueAmount] = useState(0);
  const contentRef = useRef();

  useEffect(() => {
    const fetchPlots = async () => {
      try {
        const response = await fetch(`https://api.swalokgroup.com/api/get-plots`);
        if (!response.ok) {
          throw new Error("Failed to fetch reports");
        }
        const data = await response.json();
        setPlots(data);
      } catch (error) {
        console.log(error.message);
      }
    };
    if (plots.length < 1) {
      fetchPlots();
    }
  }, [plots]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    var calculatedDueAmount = 0;

    if (name === "amount_received" || name === "total_amount") {
      const updatedAmountReceived =
        name === "amount_received" ? value : formData.amount_received;
      const updatedTotalAmount =
        name === "total_amount" ? value : formData.total_amount;
      calculatedDueAmount = updatedTotalAmount - updatedAmountReceived;
    }

    setFormData({
      ...formData,
      [name]: value,
      due_amount: calculatedDueAmount,
    });
  };


  const formatDate = (dateString) => {
    const date = new Date(dateString);

    const options = {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,  // for AM/PM format
    };

    return new Intl.DateTimeFormat("en-GB", options).format(date);
  };

  const handlePrint = useReactToPrint({
    contentRef,
    onAfterPrint: () => setShowInvoice(false),
  });

  const handleAddSale = async (e) => {
    e.preventDefault();
    setResponseMessage("");

    setShowInvoice(true);
    setTimeout(() => {
      if (contentRef.current) {
        handlePrint();
      }
    }, 400);

    // try {
    //   const response = await axios.post(
    //     "https://api.swalokgroup.com/api/add-sale",
    //     formData
    //   );
    //   if (response.status === 200) {
    //     setResponseMessage("Sale Invoice Added Successfully");
    //     setTimeout(() => {
    //       setResponseMessage("");
    //       window.location.reload();
    //     }, 1000);
    //   } else {
    //     setResponseMessage("Failed to add sale invoice. Try again later.");
    //     setTimeout(() => {
    //       setResponseMessage("");
    //     }, 1000);
    //   }
    // } catch (error) {
    //   console.error("Error:", error);
    // }
  };

  const handleFocus = () => {
    setIsDropdownVisible(true);
  };

  const handlePlotSelect = (plot) => {
    console.log(plot);
    setFormData({
      ...formData,
      plot_id: plot.id,
      plot_number: plot.plot_number,
      plot_name: plot.plot_name,
      total_sqfeet: plot.total_sqfeet,
      total_amount: plot.price * plot.total_sqfeet,
      due_amount: plot.price * plot.total_sqfeet - formData.amount_received,
    });
    setPlotData({
      length: plot.length,
      breadth: plot.breadth,
    })
    setIsDropdownVisible(false);
  };

  return (
    <section className="py-5 px-4 mb-5">
      <div className="sec-subheading">
        <hr />
        <span>Add Sale</span>
        <hr />
      </div>

      <div className="profile-area-inner mt-4">
        <p className="profile-heading">Sale Invoice</p>

        <form className="row g-3 px-4" onSubmit={handleAddSale}>
          <div className="col-md-9">
            <label htmlFor="Invoice Date" className="para-text fw-bold">
              Invoice Date
            </label>
            <br />
            <input
              type="datetime-local"
              className="form-input col-md-4"
              name="invoice_date"
              value={formData.invoice_date}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-3 float-end">
            <label htmlFor="Member Id" className="para-text fw-bold">
              Member Id
            </label>
            <br />
            <input
              type="text"
              className="form-input"
              name="member_clientid"
              value={formData.member_clientid}
              onChange={handleChange}
              required
            />
          </div>

          <div className="my-4"></div>

          <div className="col-md-4">
            <label htmlFor="Customer Name" className="para-text fw-bold">
              Customer Name
            </label>
            <input
              type="text"
              className="form-input"
              name="customer_name"
              value={formData.customer_name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-4">
            <label htmlFor="Mobile Number" className="para-text fw-bold">
              Mobile Number
            </label>
            <input
              type="tel"
              className="form-input"
              maxLength="10"
              name="customer_mobile"
              value={formData.customer_mobile}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-4">
            <label htmlFor="Customer Address" className="para-text fw-bold">
              Address
            </label>
            <input
              type="text"
              className="form-input"
              name="customer_address"
              value={formData.customer_address}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-4">
            <label htmlFor="Plot no" className="para-text fw-bold">
              Plot No
            </label>
            <input
              type="text"
              className="form-input"
              name="plot_number"
              value={formData.plot_number}
              onChange={handleChange}
              onFocus={handleFocus}
              required
            />
          </div>
          <div className="col-md-4">
            <label htmlFor="Plot Name" className="para-text fw-bold">
              Plot Name
            </label>
            <input
              type="text"
              className="form-input"
              name="plot_name"
              value={formData.plot_name}
              onChange={handleChange}
              onFocus={handleFocus}
              required
            />
          </div>

          <div className="col-md-4">
            <label htmlFor="Sq Feet" className="para-text fw-bold">
              Sq. Feet
            </label>
            <input
              type="text"
              className="form-input"
              name="total_sqfeet"
              value={formData.total_sqfeet}
              onChange={handleChange}
              onFocus={handleFocus}
              required
            />
          </div>

          {isDropdownVisible && plots.length > 0 && (
            <div
              className="bg-light py-2 px-2 table-responsive"
              style={{ height: "11em" }}
            >
              <table className="w-100" style={{ overflowY: "auto" }}>
                <thead>
                  <tr>
                    <th className="py-2 px-2">Plot Name</th>
                    <th className="py-2 px-2">Plot Number</th>
                    <th className="py-2 px-2">Length</th>
                    <th className="py-2 px-2">Breadth</th>
                    <th className="py-2 px-2">Sq. Feet</th>
                    <th className="py-2 px-2">Price/ Sq. Feet</th>
                  </tr>
                </thead>
                <tbody>
                  {plots.map((plot, index) => (
                    <tr
                      key={index}
                      className="profile-dropdown-text"
                      onClick={() => handlePlotSelect(plot)}
                    >
                      <td className="py-2 px-2">{plot.plot_name}</td>
                      <td className="py-2 px-2">{plot.plot_number}</td>
                      <td className="py-2 px-2">{plot.length}</td>
                      <td className="py-2 px-2">{plot.breadth}</td>
                      <td className="py-2 px-2">{plot.total_sqfeet}</td>
                      <td className="py-2 px-2">{plot.price}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          <div className="col-md-9">
            {/* <label htmlFor="Category" className="para-text fw-bold">
                Category
              </label><br /> */}
            <select
              className="form-input col-lg-4 col-md-5"
              name="category"
              value={formData.category}
              onChange={handleChange}
              required
            >
              <option className="contact-input" value="" disabled>
                Select Category
              </option>
              <option className="contact-input" value="Booking">
                Booking
              </option>
              <option className="contact-input" value="Agreement">
                Agreement
              </option>
              <option className="contact-input" value="Registry">
                Registry
              </option>
            </select>
          </div>

          <div className="col-md-3 d-lg-flex d-md-flex d-none">
            <label
              htmlFor="Due Amount"
              className="para-text fw-bold w-100 align-content-center"
            >
              Payable Amount
            </label>
            <input
              type="text"
              className="form-input"
              name="total_amount"
              value={formData.total_amount}
              onChange={handleChange}
              onFocus={handleFocus}
              required
            />
          </div>

          <div className="col-md-9">
            {/* <label htmlFor="Payment Method" className="para-text fw-bold">
                Method
              </label><br /> */}
            <select
              className="form-input col-lg-4 col-md-5"
              name="payment_mode"
              value={formData.payment_mode}
              onChange={handleChange}
              required
            >
              <option className="contact-input" value="" disabled>
                Payment Method
              </option>
              <option className="contact-input" value="Cash">
                Cash
              </option>
              <option className="contact-input" value="UPI">
                UPI
              </option>
              <option className="contact-input" value="Credit Card">
                Credit Card
              </option>
              <option className="contact-input" value="Debit Card">
                Debit Card
              </option>
            </select>
          </div>

          <div className="col-md-3 d-lg-flex d-md-flex d-none">
            <label
              htmlFor="Due Amount"
              className="para-text fw-bold w-100 align-content-center"
            >
              Recieved
            </label>
            <input
              type="text"
              className="form-input"
              name="amount_received"
              value={formData.amount_received}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-9 mb-lg-4">
            <input
              type="text"
              className="form-input col-lg-4 col-md-5"
              name="description"
              style={{ height: "6em" }}
              value={formData.description}
              placeholder="Description"
              onChange={handleChange}
            />
          </div>

          <div className="col-md-3 d-lg-none d-md-none">
            <label
              htmlFor="Due Amount"
              className="para-text fw-bold w-100 align-content-center"
            >
              Payable Amount
            </label>
            <input
              type="text"
              className="form-input"
              name="total_amount"
              value={formData.total_amount}
              onChange={handleChange}
              onFocus={handleFocus}
              required
            />
          </div>
          <div className="col-md-3 d-lg-none d-md-none">
            <label
              htmlFor="Due Amount"
              className="para-text fw-bold w-100 align-content-center"
            >
              Recieved
            </label>
            <input
              type="text"
              className="form-input"
              name="amount_received"
              value={formData.amount_received}
              onChange={handleChange}
              required
            />
          </div>

          <div style={{ height: "3.5rem" }} className="col-md-3 d-lg-flex d-md-flex">
            <label
              htmlFor="Due Amount"
              className="para-text fw-bold w-100 align-content-center"
            >
              Due Amount
            </label>
            <input
              type="text"
              className="form-input text-danger fw-bold"
              name="due_amount"
              value={formData.due_amount}
              placeholder="Due Amount"
              required
              disabled
            />
          </div>

          {/* <p className="text-success fw-bold mb-0">Payable Amount: {totalAmount}<br /><span className="text-danger">Due Amount: {totalAmount}</span></p> */}

          <div className="d-flex justify-content-end mt-md-0 mt-5">
            <button type="submit" className="admin-btn py-2 px-3 rounded">
              Submit
            </button>
          </div>
        </form>
        <br />
        {/* form ends */}
      </div>
      {responseMessage && (
        <div className="response-message d-flex justify-content-between">
          <p className="my-0 mx-auto">{responseMessage}</p>
          <p
            className="my-0 cursor-pointer"
            onClick={() => setResponseMessage(false)}
          >
            <i className="fa-solid fa-xmark"></i>
          </p>
        </div>
      )}


      {showInvoice && (
        <section className="invoice-outer" onClick={() => setShowInvoice(false)}>
          <div className="invoice-inner col-lg-8 col-12 mx-auto" ref={contentRef} onClick={(e) => e.stopPropagation()}>
            <div className="invoice-area">

            <p className="fw-semibold text-uppercase text-center">Invoice Receipt</p>
            {/* <hr /> */}

            <div className="row justify-content-between">

              <div className="col-6">
                <div className="invoice-box h-100">
                  <p className="fw-semibold my-0">Customer Details</p>
                  <p className="para-text">Name: {formData.customer_name}<br />
                    Mobile No: {formData.customer_mobile}<br />
                    Address: {formData.customer_address}</p>
                </div>
              </div>

              <div className="col-6">
                <div className="invoice-box h-100">
                  <p className="para-text">Invoice Date: {formatDate(formData.invoice_date)}</p>
                </div>

              </div>
            </div>
            {/* flex ends */}


            <div className="row">

              <div className="col-6 px-4 py-4">
                <p className="my-0 para-text">Site Detail</p>
                <p className="fw-semibold">Plot No: {formData.plot_id}<br />Plot Name: {formData.plot_name}</p>
              </div>

              <div className="col-6 px-4 py-4">
                <p className="my-0 para-text">Plot Detail</p>
                <p className="para-text fw-semibold">Total Sq Feet: {formData.total_sqfeet}<br />Length: {plotData.length}ft &nbsp;&nbsp;Breadth: {plotData.breadth}ft</p>
              </div>

            </div>
            {/* flex ends */}

            <p className="para-text text-end">Amount<br /><span className="fw-semibold">{formData.total_amount}</span></p>


            <div className="row para-text">

              <div className="col-6">
                <p>Payment Mode: {formData.payment_mode}<br />Plot Name: {formData.plot_name}</p>
              </div>

              <div className="col-6">
                <p>Total Amount <span className="fw-semibold">₹{formData.total_amount}</span></p>

              </div>
            </div>
            {/* row ends */}


            {/* <div className="text-start mt-4">
              <p className="para-text">Invoice Date: {formatDate(formData.invoice_date)}</p>
              <p className="fw-semibold my-0">Customer Details</p>
              <p className="para-text">Name: {formData.customer_name}<br />
                Mobile No: {formData.customer_mobile}<br />
                Address: {formData.customer_address}</p>
            </div> */}


            {/* <div className="my-4">
              <p className="fw-semibold text-center">Plot Details</p>

              <div className="table-responsive">
                <table className="w-100 para-text">

                  <tr className="bg-dark text-light">
                    <th className="fw-normal px-2 py-2">Plot No</th>
                    <th className="fw-normal px-2 py-2">Plot Name</th>
                    <th className="fw-normal px-2 py-2">Length</th>
                    <th className="fw-normal px-2 py-2">Breadth</th>
                    <th className="fw-normal px-2 py-2">Total Sq. Feet</th>
                  </tr>

                  <tr className="border-bottom">
                    <td className="px-2 py-2">{formData.plot_number}</td>
                    <td className="px-2 py-2">{formData.plot_name}</td>
                    <td className="px-2 py-2">{plotData.length}</td>
                    <td className="px-2 py-2">{plotData.breadth}</td>
                    <td className="px-2 py-2">{formData.total_sqfeet}</td>
                  </tr>

                  <tr className="bg-dark text-light">
                    <td colSpan='1' className="fw-normal px-2 py-2">Category</td>
                    <td colSpan='3' className="fw-normal px-2 py-2">Payment Mode</td>
                    <td colSpan='1' className="fw-normal px-2 py-2">Total Amount</td>
                  </tr>

                  <tr className="border-bottom">
                    <td colSpan='1' className="px-2 py-2">{formData.category}</td>
                    <td colSpan='3' className="px-2 py-2">{formData.payment_mode}</td>
                    <td colSpan='1' className="px-2 py-2">₹{formData.total_amount}</td>
                  </tr>

                </table>
              </div>
            </div> */}

            <p className="fw-semibold">Description<br />{formData.description}</p><br />
            <p className="fw-semibold my-0">Payment Detail</p>
            <p className="para-text">Amount Payable ₹{formData.total_amount}<br />
              <span className="text-success">{formData.category} Amount: ₹{formData.amount_received}</span><br />
              <span className="text-danger">Due Amount: {formData.due_amount}</span></p>

              </div>
          </div>
        </section>
      )}

    </section>
  );
};

export default AdminSale;
